export const UserEditRight = {
  CUSTOMER: 'customer',
  WORKFLOW: 'workflow',
  MASTER_DATA: 'masterData',
  USER: 'user',
  GC: 'GC',
}

export const UserRole = {
  ADMIN: 'admin',
  USER: 'user',
  VENDOR: 'vendor',
}

export const UserStatus = {
  ACTIVE: 'active',
  INACTIVE: 'inactive',
  BLOCKED: 'blocked',
}
